<template>
  <v-card>
    <v-card-title>
      {{ title }}
      <v-spacer></v-spacer>
      <v-btn @click="handleClose" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="form.cep"
              label="CEP"
              v-mask="'#####-###'"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="form.uf"
              label="Estado"
              counter="2"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.cidade"
              label="Cidade"
              counter="45"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="form.bairro"
              label="Bairro"
              counter="45"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="8">
            <v-text-field
              v-model="form.rua"
              label="Rua / Avenida"
              counter="100"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.numero"
              label="Número"
              counter="25"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          label="informações adicionais (opcional)"
          v-model="form.complemento"
          counter="45"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="handleClose" text color="primary"> Cancelar </v-btn>
      <v-btn color="primary"> Salvar </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "address-form",
  props: {
    address: {
      type: Object,
      default: () => ({})
    },
    client_ids: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: "Endereço para entrega"
    }
  },
  data: () => ({
    form: {}
  }),
  methods: {
    create() {},
    update() {},
    handleClose() {
      this.$emit("close");
    },
    changeForm(key, value) {
      this.$emit("change", {
        ...this.address,
        [key]: value
      });
    }
  }
};
</script>
